/**
 * User: nir
 * Date: 07/11/2016
 * Time: 23:06
 */
var url = window.location.href;
window.TCT = window.TCT || {};
window.TCT.Sharing = window.TCT.Sharing || {
        shareEmail: function (title, postId) {
            trackCTA('CTAShare_Email');
            trackConversion('Share_Email', title);

            branch.link({
                tags: [],
                channel: 'email',
                feature: 'web share',
                stage: '',
                data: {
                    'interrupt branch param': 'culturetrip://interrupt/showArticle?SOURCE=branch&article=' + postId,
                    '$desktop_url': url,
                    '$ios_url': url,
                    '$ipad_url': url,
                    '$og_title': 'Check out this article from \'Culture Trip\'',
                    '$og_description': "'" + title + "'"
                }
            }, function (err, link) {
                console.log(err, link);
                if (err != false) {
                }
                else {
                    link = url;
                }

                window.location.href = "mailto:?"
                    + "&subject=" + encodeURIComponent('Culture Trip - ' + title)
                    + "&body=" + encodeURIComponent('Hey, check out this awesome article on Culture Trip \n' + link);
            });
        }
    };